/* eslint-disable eqeqeq */
import React from "react";
import { Table, Skeleton } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IRequest } from "../models";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { Routes } from "../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { useGetMyRequests } from "../hooks";
import { requestStatus } from "../../../../../constants";
import { exportExcel } from "../utils";


const columns: ColumnsType<IRequest> = [
  {
    title: "Mã yêu cầu",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDateTime",
    key: "createdDateTime",
    render(value, record, index) {
      return getDDMMYYYFormat(record?.createdDateTime);
    },
  },
  {
    title: "Người tạo",
    dataIndex: "createdBy",
    key: "createdBy",
    render(value, record, index) {
      return record?.createdBy?.user?.displayName;
    },
  },
  {
    title: "Yêu cầu",
    dataIndex: "type",
    key: "type",
    render(value, record, index) {
      return <span className="flag warning">Yêu cầu</span>;
    },
  },
  {
    title: "Nghiệp vụ",
    dataIndex: "eCourse",
    key: "eCourse",
    render(value, record, index) {
      return record?.fields?.eMajor;
    },
  },
  {
    title: "Trạng thái",
    dataIndex: "eRequestStatus",
    key: "eRequestStatus",
    render(value, record, index) {

      if (record?.fields?.eRequestStatus == requestStatus.completed) {
        return <span className="flag success">Đã phê duyệt</span>;
      }


      return <ApprovalStatus status={record?.fields?.eRequestStatus} />;
    },
  },
  {
    title: "Xuất tài liệu",
    dataIndex: "Download",
    key: "Download",
    render(value, record, index) {
      return (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            exportExcel(record);
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      );
    },
  },
];

export const MyRequests: React.FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetMyRequests();

  return (
    <>
      {!isLoading && (
        <Table
          rowClassName="cursor-pointer"
          columns={columns}
          dataSource={data}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(
                  Routes.summaryEmployeeRequestDetailPage.path.replace(
                    ":id",
                    record.id
                  )
                );
              },
            };
          }}
        />
      )}
      {isLoading && <Skeleton />}
    </>
  );
};
